import { get, type RequestConfig } from "../shared/api-client";
import type { ApiListResponse } from "@project/types/location";
import type { Trustee } from "@project/types/trustee";
import { JIVANDHARA_BASE } from "../admin/list-api-helpers";

const SILENT: RequestConfig = { showNotification: false };

class TrusteeService {
  listEnabled = async (): Promise<Trustee[]> => {
    const response = await get<ApiListResponse<Trustee>>(
      `${JIVANDHARA_BASE}/trustees/`,
      {
        ...SILENT,
        params: { page: 1, page_size: 100, is_enabled: true },
      }
    );

    return (response?.data ?? [])
      .filter(item => item.is_enabled === true)
      .sort((a, b) => (a.order_by ?? 0) - (b.order_by ?? 0));
  };
}

export const trusteeService = new TrusteeService();
